import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PipeTransform } from '@angular/core';
import { ManufacturerDto } from '@dto/manufacturerDto';
import { Manufacturer } from '@models/manufacturer';
import { ManufacturersTableEntry } from '@dto/ManufacturersTableEntry'
import { Observable } from 'rxjs';
import { Setting } from '../../models/setting';
import { EntityService } from './entity.service';

@Injectable({
  providedIn: 'root'
})

export class ManufacturersService extends EntityService {

  public entityRoute = "manufacturer";

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(http, baseUrl);
  }

  static matches(manufacturer: ManufacturerDto, term: string, pipe?: PipeTransform) {
    return manufacturer.name.toLowerCase().includes(term.toLowerCase())
  }


  getAllManufacturer(): Observable<ManufacturersTableEntry[]> {
    return this.http.get<ManufacturersTableEntry[]>(this.baseUrl + 'api/manufacturer/all');
  }

  getManufacturers(): Observable<ManufacturerDto[]> {
    return this.http.get<ManufacturerDto[]>(this.baseUrl + 'api/manufacturer/')
  }

  createManufacturer(manufacturer: ManufacturerDto): Observable<ManufacturerDto> {
    return this.http.post<ManufacturerDto>(this.baseUrl + 'api/manufacturer', manufacturer);
  }
}
